import type { Rule } from 'antd/es/form';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useHtmlContentRules = (): Rule[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      ({ getFieldValue }) => ({
        validateTrigger: ['onSubmit'],
        // eslint-disable-next-line @typescript-eslint/require-await -- we need return promise with async function
        async validator(_, value) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          const attachmentsContent = getFieldValue('attachments');

          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          if ((!attachmentsContent.files || attachmentsContent.files.length === 0) && !value) {
            throw new Error(t('Error: Post cannot be empty'));
          }
        },
      }),
    ],
    [t],
  );
};
